import React from 'react';
import { Link } from 'react-router-dom';
import { connect }from 'react-redux';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/client';
import { signInWithGoogle, signOut } from '../../auth/firebaseAuth';

class Header extends React.Component {
    state = { adminName: null, circleName: null };

    // The care-circle name + admin's name live on the tenant doc. Subscribe so
    // both show in the header (a family contact can't read another user's name,
    // and needs to see which circle + admin they're in).
    subscribeTenant(tenantId) {
        if (this.unsub) { this.unsub(); this.unsub = null; }
        this.setState({ adminName: null, circleName: null });
        if (!tenantId) return;
        this.unsub = onSnapshot(doc(db, 'tenants', tenantId),
            (s) => this.setState({
                adminName: (s.exists() && s.data().adminName) || null,
                circleName: (s.exists() && s.data().name) || null,
            }),
            () => {});
    }

    componentDidMount() { this.subscribeTenant(this.props.auth && this.props.auth.tenantId); }
    componentDidUpdate(prev) {
        const prevT = prev.auth && prev.auth.tenantId;
        const curT = this.props.auth && this.props.auth.tenantId;
        if (prevT !== curT) this.subscribeTenant(curT);
    }
    componentWillUnmount() { if (this.unsub) this.unsub(); }

    renderContent() {
        const propauth = this.props.auth
        switch (propauth ){
            case null: {
                return;
            }

            case false: {
                return (<li> <button onClick={() => signInWithGoogle()} style={{fontSize:"1em", cursor:"pointer"}}>Log in with Google</button> </li> );
            }
            default: {
                const isAdminUser = propauth && propauth.role === "admin";
                const myName = (propauth && propauth.displayName)
                    || (propauth && propauth.email ? propauth.email.split("@")[0] : "");
                const adminName = this.state.adminName;
                const circleName = this.state.circleName;
                return [
                    <li key="who"><span style={{fontSize:"1em", color:"#fff", padding:"0 10px"}}>
                        {circleName && <><strong>{circleName}</strong>{"  ·  "}</>}
                        {(adminName || isAdminUser) && <>Admin: <strong>{adminName || myName}</strong></>}
                        {!isAdminUser && <>{adminName ? "  ·  " : ""}Care Circle member: <strong>{myName}</strong></>}
                    </span></li>,
                    <li key="2"> <button onClick={() => signOut()} style={{fontSize:"1em", cursor:"pointer"}}>Log out</button> </li>
                ];
            }
        }
    }

    render() {
        return  (
            <nav className="site-header">
                <div className="nav-wrapper" style={{margin:"auto"}}>
                 <Link
                    to={this.props.auth ? "/home" : "/"}
                    className="left brand-logo"
                 >
                     marysactivity.com
                 </Link>
                 <ul className="right">
                    { this.renderContent() }
                 </ul>

                </div>
            </nav>

        )
    }
}

const mapStateToProps = state => {
  return {  auth: state.auth }
}

export default connect(mapStateToProps, null)( Header);
